import decode from 'jwt-decode';
import Router from 'vue-router';
import store from '@/store';

const router = new Router({
  mode: 'history'
});

export function logout() {
  clearToken();
  router.go('/login');
}

export async function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    if (!store.getters.UserIsAuthenticated) {
      await store.dispatch('authenticateUser');
    }
    if (userHasPermission(to) === false) {
      next({ name: 'NotFound404' });
    }
    next();
  }
}

export async function redirectToUserHome(to, from, next) {
  if (isLoggedIn() && to.fullPath === '/') {
    const { UserIsAuthenticated, UserHasRole } = store.getters;

    if (!UserIsAuthenticated) {
      await store.dispatch('authenticateUser');
    }

    if (UserHasRole('Platform')) {
      next({ name: 'Dashboard' });
    } else if (UserHasRole('Provider')) {
      next({ name: 'Funders' });
    } else if (UserHasRole('Partner')) {
      next({ name: 'Dashboard' });
    } else if (UserHasRole('Bank')) {
      next({ name: 'Banks' });
    } else if (UserHasRole('Call Centre') || UserHasRole('Broker')) {
      next({ name: 'Referrals' });
    }
  }

  next();
}

export function setToken(token) {
  localStorage.setItem('jwt', token);
}

export function getToken() {
  return localStorage.getItem('access_token');
}

function clearToken() {
  localStorage.removeItem('access_token');
}

export function isLoggedIn() {
  const token = getToken();

  return !!token && !isTokenExpired(token);
}

function getTokenExpirationDate(encodedToken) {
  const token = decode(encodedToken);
  if (!token.exp) {
    return null;
  }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);

  return expirationDate < new Date();
}

function userHasPermission(location) {
  const requiredRoles = location.matched.reduce((roles, record) => {
    return record.meta.requiresRole ? roles.concat(record.meta.requiresRole) : roles;
  }, []);

  return requiredRoles.length > 0 ? requiredRoles.some(role => store.getters.UserHasRole(role)) : true;
}
